import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

export const getAllSystemVendorInvoicesForWorkflow = async () => {
  try {
    const response = await apiClient.get(
      '/systemInvoiceManagement/workflow/all-system-vendor-invoices'
    );
    if (response.data?.response && Array.isArray(response.data.response)) {
      return response.data.response;
    }
    return response.data?.response || response.data || [];
  } catch (error) {
    handleApiError(error);
  }
};
